import React from "react"
import "@fortawesome/fontawesome-svg-core/styles.css"
import "./src/components/Layout.css"
import AgeGate from "./src/components/common/AgeGate"

// 年齢確認は全ページ（Layout を使わないページも）に出す
export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <AgeGate />
  </>
)
